export default "__VITE_ASSET__DhjsAjFO__"